import {List, Map} from 'immutable';
import {CycleFetch} from 'helpers/api';
import {api} from 'helpers/api';
import {success, error} from 'helpers/response';

const initialState = new Map({
});

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    }
    return state;
}

export const getTelematicsWithDevices = (devices, source, boundingBox, mapSize, zoom) => async (dispatch) => {
    try {
        const response = await api.telematics.getTelematicsWithDevices(devices, source, boundingBox, mapSize, zoom);

        return success(response);
    }
    catch (e) {
        return error(e);
    }
};

export const getTelematics = (component, source, boundingBox, mapSize, zoom) => async (dispatch) => {
    try {
        const response = await api.telematics.getTelematics(component, source, boundingBox, mapSize, zoom);

        return success(response);
    }
    catch (e) {
        return error(e);
    }
};

export const getTelematicsTotalCount = () => async (dispatch) => {
    try {
        const response = await api.telematics.getTelematicsTotalCount();

        return success(response);
    }
    catch (e) {
        return error(e);
    }
};


// WEBPACK FOOTER //
// ./src/store/reducers/maps.js